import { createAction } from 'redux-act'

export const loadNavBar=createAction()
export const loadNavBar2=createAction()
export const loadSideBar=createAction()